import { render } from "./CareerView.vue?vue&type=template&id=10674cbf&scoped=true"
import script from "./CareerView.vue?vue&type=script&lang=js"
export * from "./CareerView.vue?vue&type=script&lang=js"

import "./CareerView.vue?vue&type=style&index=0&id=10674cbf&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10674cbf"]])

export default __exports__